<template>
  <div class="wrap talk" v-if="!isComplete">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>

    <div class="container">
      <main class="content">
        <article class="certification">
          <section class="txt tit">
            <h1>사진업로드 및 정보삭제안내</h1>
          </section>
          <section>
            <div class="con-box info">
              <ol>
                <li>
                    반납하시는 노트북의 정면, 후면(모델명,S/N식별가능) 사진을 촬영 업로드 해주시고 개인정보 우선삭제 내용은 중요사항으로 참고하세요
                </li>
                <li>아래 사진 예시 확인하시고, 촬영 업로드 진행 바랍니다.</li>
                <!-- <li>개인정보 우선 삭제 진행 동의여부 체크 바랍니다.</li> -->
              </ol>
            </div>
          </section>
          <section>
            <div class="con-box">
              <h2>사진업로드</h2>
              <div class="photo-info">
                <p>
                  사진 촬영 업로드 예시<br /><span class="gray8"
                    >(모델명, S/N확인 가능하도록 촬영 업로드)</span
                  >
                </p>
                <div class="imgbox">
                  <img
                    src="@/assets/images/ex_3.png"
                    style="max-width: 100%; height: auto"
                    alt=""
                  />
                  <span class="title-box">정면예시</span>
                </div>
                <div class="imgbox">
                  <img
                    src="@/assets/images/ex_2.jpg"
                    style="max-width: 100%; height: auto"
                    alt=""
                  />
                  <span class="title-box">후면예시</span>
                </div>
                <!-- <div>
                  <ImageUpload
                    :initFileName="fileName"
                    @changeFileName="changeFileName"
                  />
                </div>                 -->
                <div class="text-box addfile">
                  <input
                    ref="pcImage"
                    type="file"
                    accept="image/*"
                    @change="uploadImage()"
                    multiple="multiple"
                  />
                  <button type="button" class="btn-file">파일선택</button>
                </div>
                <!-- 첨부파일 이미지 미리보기 이미지  -->
                <div class="imgbox-view">
                  <div class="info-box">
                    <a href="javascript:void(0);">
                      <img
                        name="pcImage"
                        id="pcImage0"
                        src="@/assets/images/character.png"
                        alt="Front Image"
                      />
                      <span class="btn-close" @click="delImg(0)"
                        ><i class="xi-close-min"></i
                      ></span>
                    </a>
                    <a href="javascript:void(0);">
                      <img
                        name="pcImage"
                        id="pcImage1"
                        src="@/assets/images/character.png"
                        alt="Back Image"
                      />
                      <span class="btn-close" @click="delImg(1)"
                        ><i class="xi-close-min"></i
                      ></span>
                    </a>
                  </div>
                </div>
                <!-- //첨부파일 이미지 미리보기 이미지  -->
              </div>
            </div>
          </section>
          <section>
            <div class="con-box info-check">
              <p>
                판매하실 노트북에 남아있는 소중한
                <span class="black">개인정보 유출 방지를 위해,</span> 평가센터
                도착 즉시 민팃의 '개인정보 완전 삭제 솔루션'을 통해
                반납기기의 데이터 즉시 삭제 후 데이터삭제 인증서를 발송해 드립니다.
                <br /><br />
                * 노트북 보상 신청을 철회하시는 경우에도 데이터 복구는 불가한 상태입니다.
              </p>
              <p class="mar_t20 red">
                <strong>개인정보 완전삭제 솔루션</strong>
              </p>
              <p class="mar_t5 red">
                저장장치에 남아있는 운영체제(OS)까지 복원되지 않는 상태로 완전
                삭제되며, 삭제 후 데이터 삭제 인증서를 발송해 드립니다.
              </p>
              <div v-if="false" class="input-area mar_t20 aC">
                <div class="label-check">
                  <label>
                    <input
                      id="dataDelAgrmYn1"
                      type="radio"
                      value="Y"
                      name="dataDelAgrmYn"
                      checked="checked"
                    />
                    <span>동의</span>
                  </label>
                  <label>
                    <input
                      id="dataDelAgrmYn2"
                      type="radio"
                      value="N"
                      name="dataDelAgrmYn"
                    />
                    <span>미동의</span>
                  </label>
                </div>
              </div>
            </div>
          </section>
          <!-- 버튼  -->
          <div class="btn-wrap">
            <a
              href="javascript:void(0);"
              class="talk-btn btn-black"
              @click.stop.prevent="save"
              >등록하기</a
            >
          </div>
          <!-- //버튼  -->
        </article>
      </main>
    </div>
  </div>
  <div class="wrap talk" v-else-if="isComplete">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content">
        <article class="certification">
          <section class="txt tit">
            <h1>사진업로드 및 정보삭제동의 등록 완료</h1>
          </section>

          <section class="ro-top">
            <div class="box1 row row_c row_jsc">
              <span><i class="xi-check"></i></span>
              <p>사진업로드 및 정보삭제동의가 등록<br />되었습니다.</p>
            </div>
          </section>
        </article>
      </main>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'

/** 이미지 유틸 */
import axios from 'axios'
import ImageUpload from '@/views/purchase/cmm/ImageUpload'

export default {
  name: 'PcPhtgUpld',
  components: {
    ImageUpload
  },
  data: () => ({
    isComplete: false,
    ordNum: '',
    AppConfig: AppConfig,
    srcImg: null, // when mounted , data Setting
    maxSize: 10 * 1024 * 1024, // 10MB
    upLoadFiles: null
  }),
  computed: {},
  mounted () {
    this.PcPhtgUpldInit()
  },
  methods: {
    //
    showLoading: function (name) {
      var html =
        '<div id="loading" name="loading" class="' +
        name +
        '"><div class="car"></div></div>'
      $('html').append(html)
      $('.' + name).show()
    },
    hideLoading: function (name) {
      $('.' + name).hide()
      $('.' + name).remove()
    },
    delImg: function (imgNum) {
      console.log(' imgNum =>> ', imgNum)

      //   var arrFiles = Array.from(this.upLoadFiles);
      //   arrFiles.splice(imgNum, 1);

      //   const dT = new DataTransfer();
      //   for (const aFile of arrFiles) { dT.items.add(aFile); }
      //   this.upLoadFiles = dT.files;

      // console.log(" UpLoad Image Length : " + this.upLoadFiles.length )

      var eImg = document.getElementsByName('pcImage')
      eImg[imgNum].src = this.srcImg
    },
    uploadImage: function (e) {
      var imgFiles = this.$refs['pcImage'].files
      
      var chkFileName = ''
      for(var i=0 ; i < imgFiles.length ; i++){
    	  console.log('파일명 : ', imgFiles[i].name)
    	  chkFileName = imgFiles[i].name.slice(imgFiles[i].name.indexOf(".") + 1).toLowerCase()
    	  
    	  if(chkFileName != "jpg" && chkFileName != "jpeg" && chkFileName != "png" &&  chkFileName != "gif" &&  chkFileName != "bmp"){
    		  alert("이미지 파일은 (jpg, jpeg, png, gif, bmp) 형식만 등록 가능합니다.")
    		  return
    	  }
      }

      var eImgs = document.getElementsByName('pcImage')
      var inSrcImg = this.srcImg

      var eImgsIdx = 0
      for (var zzz = 0; zzz < eImgs.length; zzz++) {
        if (inSrcImg == eImgs[zzz].src) {
          eImgsIdx++ // 업로드 안된 이미지 갯수
        }
      }

      if (imgFiles.length > eImgsIdx) {
        // 업로드 할려는 이미지 갯수를 제한
        alert('이미지 파일은 2개까지 등록가능 합니다!(전면, 후면)')
        return
      }

      console.log('First upLoadFiles :', this.uploadFiles)
      if (this.upLoadFiles == null) {
        console.log('First')
        this.upLoadFiles = imgFiles
        this.tmpUpLoadFiles = Array.from(this.upLoadFiles)
      }

      var tmpUpLoadFiles = this.tmpUpLoadFiles
      var arrFiles = Array.from(imgFiles)

      console.log('tmpUpLoadFiles : ', this.tmpUpLoadFiles)

      var reader = new FileReader()
      function readFile (index) {
        if (index >= imgFiles.length) return
        reader.onload = function (e) {
          var rIdx = 0
          while (true) {
            if (rIdx > 1) break
            if (inSrcImg == eImgs[rIdx].src) {
              eImgs[rIdx].src = reader.result
              tmpUpLoadFiles.splice(rIdx, 1, arrFiles[index])
              break
            }
            rIdx++
          }
          readFile(index + 1)
        }
        reader.readAsDataURL(imgFiles[index])
      }
      readFile(0)
    },
    async save () {
      var eImgsIdx = 0
      var eImgs = document.getElementsByName('pcImage')
      var inSrcImg = this.srcImg

      for (var zzz = 0; zzz < eImgs.length; zzz++) {
        if (inSrcImg == eImgs[zzz].src) {
          eImgsIdx++ // 업로드 안된 이미지 갯수
        }
      }

      console.log(' eImgsIdx : ', eImgsIdx)

      if (eImgsIdx != 0) {
        alert('이미지 파일을 2개(전면, 후면)을 등록해 주세요!')
        return
      }

      var tmpUpLoadFiles = this.tmpUpLoadFiles

      const dT = new DataTransfer()
      for (const tFile of tmpUpLoadFiles) {
        if (tFile != null) dT.items.add(tFile)
      }
      this.upLoadFiles = dT.files

      var upLoadFiles = this.upLoadFiles
      var maxSize = this.maxSize

      console.log(' upload File : ', this.upLoadFiles)

      for (const uFile of upLoadFiles) {
        if (uFile.size > maxSize || uFile.size > maxSize) {
          alert('첨부파일 사이즈 10MB 이내로 등록 가능합니다.')
          return
        }
      }

      // 삭제 동의, 미동의
      var dataDelAgrmYn = 'Y'

      const fd = new FormData()
      for (const uFile of upLoadFiles) {
        fd.append('files', uFile)
      }

      fd.append(
        'dataDelAgrmYn',
        new Blob([dataDelAgrmYn], { type: 'application/json' })
      )
      fd.append(
        'ordNum',
        new Blob([this.ordNum], { type: 'application/json' })
      )

      console.log('FormData : ', fd)

      const isTrue = await this.$Alert.confirm(
        '사진업로드 및 정보삭제동의를 진행 하시겠습니까?'
      )
      if (!isTrue) return

      this.showLoading('Uploading')

      // const { data } = await Vue.httpClient.post('/api/purchase/pcs/etc/public/pcFileRegister',
      const { data } = await this.$http.post(
        '/api/purchase/pcs/etc/public/pcFileRegister',
        fd,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )

      if (data.status === '200') {
        this.isComplete = true
      } else {
      }

      this.hideLoading('Uploading')
    },
    async PcPhtgUpldInit () {
      this.uploadFiles = this.$refs['pcImage'].files
      this.srcImg = document.getElementById('pcImage0').src // Template 정보

      this.ordNum = this.$route.query.ordNum

      console.log(' ===> ordNum :', this.ordNum)

      if (
        this.ordNum == undefined ||
        this.ordNum == null ||
        this.ordNum == ''
      ) {
        alert('주문번호가 없습니다!')
      }

      const params = {
        ordNum: this.ordNum
      }

      console.log('upalodFiles ===> ', this.uploadFiles)
      console.log('params ==> {}', params)

      const rtn = await Vue.httpClient
        .get('/api/purchase/pcs/mgmt/public/ord-num', { params })
        .then((res) => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            console.log('===> ordNum Result : ', res.data)
            if (res.data.result == undefined) {
              alert('주문정보가 없습니다!')
            }
          } else {
            alert(' 주문번호가 올바르지 않습니다!')
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/PcPhtgUpld.vue